import { render, staticRenderFns } from "./SocialServeGov.vue?vue&type=template&id=5d10aa8c&scoped=true&"
import script from "./SocialServeGov.vue?vue&type=script&lang=js&"
export * from "./SocialServeGov.vue?vue&type=script&lang=js&"
import style0 from "./SocialServeGov.vue?vue&type=style&index=0&id=5d10aa8c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d10aa8c",
  null
  
)

export default component.exports